import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

interface Props {
    description?: string | null;
    sx?: object;
}

export default function SectionDescription({ description, sx }: Props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const trimmed = description?.trim();
    if (!trimmed) return null;

    return (
        <Box sx={{ padding: '0px 16px 0px 0px', marginTop: '12px', ...sx }}>
            <Typography
                variant="body1"
                sx={{
                    color: 'text.primary',
                    fontSize: isMobile ? 14 : 16,
                    lineHeight: isMobile ? '20px' : '24px',
                    whiteSpace: 'pre-wrap',
                }}
            >
                {trimmed}
            </Typography>
        </Box>
    );
}
